import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { handleDownloadExcel, TableViewRekapLpp } from '../../../../controller/index2';
import { fetchLppListDpha, fetchLppRekapDpha, fetchPostDataLppDpha } from "../../../../controller/dashboard/Cekmeter";
import { getCache } from "../../../../util/Cache";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faUndo, faRedo, faSpinner, faCircleExclamation } from '@fortawesome/free-solid-svg-icons'

export default function Rlpp(){
    const [petugas, setPetugas] = useState<any>({});

    const handleSetPetugas = async () => {
        const dataLogin = await getCache("current_user");
        setPetugas(dataLogin);
    }

    const [tanggalChoose, setTanggalChoose] = useState<Date | null>(new Date());
    const [namaSmbChoose, setnamaSmbChoose] = useState<string>("");
    const [tanggalString, setTanggalString] = useState<string>("");
    const [tanggalStringRapi, setTanggalStringRapi] = useState<string>("");
    const [loadingExportExcel, setLoadingExportExcel] = useState<boolean>(false);

    useEffect(() => {
        if (!tanggalChoose) {
            setTanggalString(""); 
            setTanggalStringRapi("");
            return; 
        }

        const y = tanggalChoose.getFullYear().toString().slice(-2);
        const m = (tanggalChoose.getMonth() + 1).toString().padStart(2, '0');
        const d = tanggalChoose.getDate().toString().padStart(2, '0');
        
        setTanggalString(`${y}${m}${d}`);
        setTanggalStringRapi(`${d}-${m}-${y}`);
    },[tanggalChoose])


    const [filteredLppDetail, setFilteredLppDetail] = useState<any[]>([]);
    const [listDataRekapLpp, setListDataRekapLpp] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [checkedTransfers, setCheckedTransfers] = useState<Record<string, string>>({});
    const [error, setError] = useState<string | null>(null);

    // History untuk undo/redo
    const [history, setHistory] = useState<Record<string, string>[]>([{}]);
    const [historyIndex, setHistoryIndex] = useState(0);

    const [selectedKls, setSelectedKls] = useState(""); 
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");

    const filterLppDetail = filteredLppDetail.filter(lpp => {
        const nama = lpp.NAMA?.toLowerCase() || "";
        const nsb = lpp.NOSAMW?.toLowerCase() || "";
        const search = namaSmbChoose?.toLowerCase() || "";

        const matchesSearch =
            nama.includes(search) ||
            nsb.includes(search);
        return matchesSearch;
    });

    const initDataDPHA = async () => {
        setLoading(true);
          try {
            const dpha = `DPHA${tanggalString}${petugas.loket}`;
            const resp = await fetchLppListDpha(dpha);
            setFilteredLppDetail(resp.data);
          } catch (err: any) {
            setError(String(err?.message ?? err));
          } finally {
            setLoading(false);
        }
    }

    const initDataRekapanDPHA = async () => {
      // setLoading(true);
      try {
        const dpha = `DPHA${tanggalString}${petugas.loket}`;
        const resp = await fetchLppRekapDpha(dpha);
        console.log("Rekap Lpp");
        console.log(resp);
        setListDataRekapLpp(resp.data);
      } catch (err: any){
        setError(String(err?.message ?? err));
      } finally {
        // ..
      }
    }

    useEffect(() => {
        handleSetPetugas();
    }, []);

    useEffect(() => {
        if(petugas.nama){
            let mounted = true;
            initDataDPHA();
            initDataRekapanDPHA();
            return () => { mounted = false; };
        }
    }, [tanggalString, petugas]);

    // Keyboard shortcuts untuk undo/redo
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
                e.preventDefault();
                handleUndo();
            } else if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.shiftKey && e.key === 'z'))) {
                e.preventDefault();
                handleRedo();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [historyIndex, history]);

    const handleToggleTransfer = (id: string) => {
        if (!id) return;

        setCheckedTransfers(prev => {
            const updated = { ...prev };

            if (updated[id]) {
                delete updated[id];
            } else {
                const now = new Date();
                const dd = String(now.getDate()).padStart(2, "0");
                const mm = String(now.getMonth() + 1).padStart(2, "0");
                const yy = String(now.getFullYear()).slice(-2);

                updated[id] = `${dd}${mm}${yy}`;
            }

            // Update history
            const newHistory = history.slice(0, historyIndex + 1);
            newHistory.push(updated);
            setHistory(newHistory);
            setHistoryIndex(newHistory.length - 1);

            return updated;
        });
    };

    const handleTransferDate = (id: string, date: string) => {
        setCheckedTransfers(prev => {
            const updated = { ...prev, [id]: date };

            // Update history
            const newHistory = history.slice(0, historyIndex + 1);
            newHistory.push(updated);
            setHistory(newHistory);
            setHistoryIndex(newHistory.length - 1);

            return updated;
        });
    };

    const handleUndo = () => {
        if (historyIndex > 0) {
            const newIndex = historyIndex - 1;
            setHistoryIndex(newIndex);
            setCheckedTransfers(history[newIndex]);
        }
    };

    const handleRedo = () => {
        if (historyIndex < history.length - 1) {
            const newIndex = historyIndex + 1;
            setHistoryIndex(newIndex);
            setCheckedTransfers(history[newIndex]);
        }
    };

    const handleResetCheckers = () => {
        setCheckedTransfers({});
        const newHistory = history.slice(0, historyIndex + 1);
        newHistory.push({});
        setHistory(newHistory);
        setHistoryIndex(newHistory.length - 1);
    };

    return(
        <>
            <div className="w-full max-w-screen px-2 md:px-4 lg:px-6 mx-auto">
                <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 mb-6">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-6 print:hidden">
                        <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                            Rekap LPP {tanggalStringRapi}:  {petugas.nama}, LOKET - {petugas.loket}
                        </h3>
                    </div>

                    {/* Grid Layout: Table (Left) + Sticky Controls (Right) */}
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                        {/* Table Section - 9 columns */}
                        <div className="lg:col-span-9">
                            <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
                                {
                                loading ? (
                                    <div className="w-full p-8 text-center text-yellow-500">Sedang Loading <FontAwesomeIcon icon={faSpinner} spin /> </div>
                                ) : filterLppDetail && filterLppDetail.length >= 1 ? (
                                    <DetailPreviewRekapLppTableModal
                                        filteredLppDetail={filterLppDetail}
                                        checkedTransfers={checkedTransfers}
                                        handleToggleTransfer={handleToggleTransfer}
                                        handleTransferDate={handleTransferDate}
                                    />
                                ) : (
                                    <div className="w-full p-8 text-center text-red-500">Tidak ada data <FontAwesomeIcon icon={faCircleExclamation} /> </div>
                                )}
                            </div>
                        </div>

                        {/* Sticky Controls Section - 3 columns */}
                        <div className="lg:col-span-3">
                            <div className="sticky top-4 flex flex-col gap-3">
                                <input
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setnamaSmbChoose(e.target.value)}
                                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm"
                                    placeholder="Nama atau NO. SMB" 
                                />
                                <DatePicker
                                    selected={tanggalChoose}
                                    onChange={(date: Date | null) => setTanggalChoose(date)}
                                    placeholderText="Pilih tanggal bayar"
                                    dateFormat="yyyy-MM-dd"
                                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm"
                                    isClearable
                                />
                                
                                {/* Undo/Redo Buttons */}
                                <div className="flex gap-2">
                                    <button
                                        onClick={handleUndo}
                                        disabled={historyIndex <= 0}
                                        title="Ctrl+Z"
                                        className="flex-1 px-3 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors text-sm font-medium flex items-center justify-center gap-1"
                                    >
                                        <FontAwesomeIcon icon={faUndo} />
                                        <span>Undo</span>
                                    </button>
                                    <button
                                        onClick={handleRedo}
                                        disabled={historyIndex >= history.length - 1}
                                        title="Ctrl+Y"
                                        className="flex-1 px-3 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors text-sm font-medium flex items-center justify-center gap-1"
                                    >
                                        <FontAwesomeIcon icon={faRedo} />
                                        <span>Redo</span>
                                    </button>
                                </div>

                                <button
                                    onClick={handleResetCheckers}
                                    className="px-4 py-2 text-white bg-red-500 rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
                                >
                                    Reset Centangan
                                </button>
                                {filterLppDetail && filterLppDetail.length >= 1 && (
                                    <>
                                    <button
                                        onClick={async () => {
                                            setLoadingExportExcel(true);

                                            if (filterLppDetail && filterLppDetail.length > 0) {
                                                const response = await handleDownloadExcel(filteredLppDetail, {
                                                    filterKls: selectedKls,
                                                    filterBln: selectedMonth,
                                                    filterThn: selectedYear,
                                                    checkedTransfers: checkedTransfers,
                                                }, `DPHA${tanggalString}${petugas.loket}`);

                                                await fetchPostDataLppDpha(response, petugas.loket, petugas.nama, `DPHA${tanggalString}${petugas.loket}`)
                                                await initDataRekapanDPHA();
                                            }
                                            setLoadingExportExcel(false);
                                        }}
                                        className="flex items-center justify-center px-4 py-2 text-white bg-green-500 rounded-lg hover:bg-green-700 transition-colors text-sm font-medium gap-2"
                                        disabled={loadingExportExcel}
                                    > 
                                      {
                                        loadingExportExcel ?
                                        (
                                          <>
                                            <FontAwesomeIcon icon={faSpinner} />
                                            <span>Loading</span>
                                          </>
                                        )
                                        :
                                        (
                                          <>
                                            <FontAwesomeIcon icon={faFileExcel} />
                                            <span>Download</span>
                                          </>
                                        )
                                      }
                                        
                                    </button>
                                      {
                                        listDataRekapLpp.length === 0 ?
                                        <>  
                                          <div className="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
                                            <h4 className="mb-2 text-sm font-semibold text-gray-700">Tidak Rekapan</h4>
                                          </div>
                                        </>
                                        :
                                          <>
                                            <div className="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
                                              <h4 className="mb-2 text-sm font-semibold text-gray-700">History Rekapan</h4>
                                              <div className="max-h-64 space-y-2 overflow-y-auto pr-1">
                                                {
                                                  listDataRekapLpp.map((data: any, idx: number) => 
                                                    <div className="rounded-md border border-gray-200 bg-white px-3 py-2">
                                                      <div className="flex items-center justify-between gap-2">
                                                        <span className="text-sm font-medium text-gray-800">{idx + 1}. REKAP : {data.KODE_BYR}</span>
                                                        <span className="rounded-full bg-green-100 px-2 py-1 text-xs text-green-700">Loket {data.LOKET}</span>
                                                      </div>
                                                      <p className="mt-1 text-xs text-gray-500">{data.PETUGAS} - {new Date(data.modified_at).toLocaleString('id-ID')}</p>
                                                    </div>
                                                  )
                                                }
                                              </div>
                                            </div>
                                          </>
                                        
                                      }
                                    </>
                                    
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export const DetailPreviewRekapLppTableModal = ({
  filteredLppDetail,
  checkedTransfers,
  handleToggleTransfer,
  handleTransferDate, // ✅ prop baru
}: {
  filteredLppDetail:   any[];
  checkedTransfers:    Record<string, string>; // ✅ ubah dari string[] ke Record
  handleToggleTransfer: (id: string) => void;
  handleTransferDate:   (id: string, date: string) => void; // ✅ prop baru
}) => {
  const { rows, totals } = TableViewRekapLpp(filteredLppDetail);
 
  // ✅ Helper: format Date "YYYY-MM-DD" → "DDMMYY" untuk dikirim ke TableViewRekapLpp2
  const formatToShort = (isoDate: string): string => {
    if (!isoDate) return "";
    const [y, m, d] = isoDate.split("-");
    if (!y || !m || !d) return "";
    return `${d}${m}${y.substring(2)}`; // "02-12-2026" → "021226"
  };
 
  return (
    <table className="w-full border-collapse text-xs md:text-sm">
      <thead className="bg-gray-100 sticky top-0">
        <tr>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">NO</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">PERIODE</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">NSB</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">NAMA</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">KLS</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">PLGGN</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">HAIR</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">ADM</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">JML</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">DENDA</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">TOTAL</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">KET</th>
          <th className="border border-gray-300 px-2 py-1.5 font-semibold">TRANSFER?</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows.map((r: any, idx: number) => {
            // A. RENDER HEADER GRUP
            if (r.is_group_header) {
              return (
                <tr key={`group-${idx}`} className="font-bold">
                  <td colSpan={13} className="border border-gray-300 px-2 py-1.5 text-center uppercase bg-gray-100">
                    {/* {r.label} */}
                  </td>
                </tr>
              );
            }
 
            // B. RENDER BARIS SPACER
            if (r.no === "" && !r.is_summary && r.nama === "") {
              return <tr key={`spacer-${idx}`} className="h-2 bg-gray-50"></tr>;
            }
 
            // C. RENDER BARIS TOTAL KECAMATAN
            if (r.is_kec_total) {
              return (
                <tr key={`kec-total-${idx}`} className="font-bold bg-blue-50">
                  <td colSpan={6} className="border border-gray-300 px-2 py-1.5 text-center uppercase">{r.nama}</td>
                  <td className="border border-gray-300 px-2 py-1.5 text-right">{r.hair}</td>
                  <td className="border border-gray-300 px-2 py-1.5 text-right">{r.adm}</td>
                  <td className="border border-gray-300 px-2 py-1.5 text-right">{r.jml}</td>
                  <td className="border border-gray-300 px-2 py-1.5 text-right">{r.dnd}</td>
                  <td className="border border-gray-300 px-2 py-1.5 text-right">{r.ttl}</td>
                  <td className="border border-gray-300 px-2 py-1.5" colSpan={2}></td>
                </tr>
              );
            }
 
            // D. RENDER DATA & SUB-TOTAL
            const isChecked   = r.uniqueId !== undefined && checkedTransfers[r.uniqueId] !== undefined;
            // Nilai ISO "YYYY-MM-DD" untuk value input date
            const isoDateVal  = isChecked
              ? (() => {
                  const short = checkedTransfers[r.uniqueId]; // "DDMMYY"
                  if (!short || short.length < 6) return new Date().toISOString().split('T')[0];
                  const dd = short.substring(0, 2);
                  const mm = short.substring(2, 4);
                  const yy = short.substring(4, 6);
                  return `20${yy}-${mm}-${dd}`;
                })()
              : new Date().toISOString().split('T')[0];
 
            return (
              <tr
                key={idx}
                className={`${r.is_summary ? "font-bold" : ""} hover:bg-gray-50 transition-colors`}
              >
                <td className="border border-gray-300 px-2 py-1.5 text-center">{r.no}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-center">{r.periode}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-center">{r.nsb}</td>
                <td className="border border-gray-300 px-2 py-1.5">{r.nama}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-center">{r.kls}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-center">{r.plggn}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-right">{r.hair}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-right">{r.adm}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-right">{r.jml}</td>
                <td className="border border-gray-300 px-2 py-1.5 text-right">{r.dnd}</td>
                <td className={`border border-gray-300 px-2 py-1.5 text-right ${!r.is_summary && 'font-semibold'}`}>
                  {r.ttl}
                </td>
                <td className="border border-gray-300 px-2 py-1.5 text-xs italic text-gray-600">{r.ket}</td>
 
                {/* Kolom TRANSFER */}
                <td className="border border-gray-300 px-2 py-1.5 text-center">
                  {!r.is_group_header && !r.is_summary && (
                    <div className="flex items-center justify-center gap-1">
                      {/* Checkbox */}
                      <input
                        type="checkbox"
                        className="w-3.5 h-3.5 cursor-pointer"
                        checked={isChecked}
                        onChange={() => handleToggleTransfer(r.uniqueId)}
                      />
 
                      {/* ✅ Date input — muncul saat dicentang, value tersimpan ke state */}
                      {isChecked && (
                        <input
                          type="date"
                          className="border border-gray-300 rounded px-1.5 py-0.5 text-xs"
                          value={isoDateVal}
                          onChange={(e) => {
                            // Simpan dalam format pendek "DDMMYY"
                            handleTransferDate(r.uniqueId, formatToShort(e.target.value));
                          }}
                        />
                      )}
                    </div>
                  )}
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={13} className="text-center py-2 text-gray-500">Tidak ada data</td>
          </tr>
        )}
 
        {/* E. GRAND TOTAL */}
        {rows.length > 0 && (
          <tr className="font-bold bg-yellow-100">
            <td colSpan={6} className="border border-gray-300 px-2 py-1.5 text-center">TOTAL</td>
            <td className="border border-gray-300 px-2 py-1.5 text-right">{totals.formatted.shair}</td>
            <td className="border border-gray-300 px-2 py-1.5 text-right">{totals.formatted.sadm}</td>
            <td className="border border-gray-300 px-2 py-1.5 text-right">{totals.formatted.sjml}</td>
            <td className="border border-gray-300 px-2 py-1.5 text-right">{totals.formatted.sdnd}</td>
            <td className="border border-gray-300 px-2 py-1.5 text-right">{totals.formatted.sttl}</td>
            <td className="border border-gray-300 px-2 py-1.5" colSpan={2}></td>
          </tr>
        )}
      </tbody>
    </table>
  );
};